import React, { useEffect, useState } from "react";
import "./Pagination.css";

const Pagination = ({ totalPages, currentPage, setCurrentPage, setLimit, limit }) => {
    const [visiblePages, setVisiblePages] = useState([]);

    useEffect(() => {
        updateVisiblePages(currentPage);
    }, [currentPage]);

    const updateVisiblePages = (page) => {
        const pages = [];

        if (totalPages === 1) {
            pages.push(1);
        } else {
            pages.push(1);

            if (page > 3) {
                pages.push("...");
            }

            const startPage = Math.max(2, page - 2);
            const endPage = Math.min(totalPages - 1, page + 2);

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }

            if (page < totalPages - 2) {
                pages.push("...");
            }

            pages.push(totalPages);
        }

        setVisiblePages(pages);
    };

    const onNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const onPrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div className="pagination_main">
            <div className="option_select">
                {limit && (
                    <select
                        id="pagination-dropdown"
                        onChange={(e) => setLimit(e.target.value)}
                        value={limit}
                    >
                        <option id="pagination-dropdown-10" value={10}>
                            10
                        </option>
                        <option id="pagination-dropdown-20" value={20}>
                            20
                        </option>
                        <option id="pagination-dropdown-50" value={50}>
                            50
                        </option>
                        <option id="pagination-dropdown-100" value={100}>
                            100
                        </option>
                    </select>
                )}
            </div>

            {(totalPages || totalPages >= 1) && (
                <div className="pagination_count">
                    <ul>
                        {visiblePages.map((page, index) => (
                            <li
                                key={index}
                                className={page === currentPage ? "active_page" : ""}
                                id={`page-click-${page}`}
                                onClick={() => typeof page === "number" && setCurrentPage(page)}
                            >
                                {page}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            <div className="d-flex align-items-center gap-3">
                <button
                    onClick={onPrevious}
                    disabled={currentPage === 1 || !currentPage}
                    id="previous-page"
                >
                    <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2.16669 4.99984L1.45958 4.29273L0.752473 4.99984L1.45958 5.70694L2.16669 4.99984ZM12.1667 5.99984C12.719 5.99984 13.1667 5.55212 13.1667 4.99984C13.1667 4.44755 12.719 3.99984 12.1667 3.99984V5.99984ZM4.79291 0.959397L1.45958 4.29273L2.87379 5.70694L6.20713 2.37361L4.79291 0.959397ZM1.45958 5.70694L4.79291 9.04028L6.20713 7.62606L2.87379 4.29273L1.45958 5.70694ZM2.16669 5.99984H12.1667V3.99984H2.16669V5.99984Z"
                            fill="#fff"
                        />
                    </svg>
                    Previous
                </button>
                <button
                    onClick={onNext}
                    disabled={currentPage === totalPages || !currentPage}
                    id="next-page"
                >
                    Next
                    <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M11.8333 4.99984L12.5404 4.29273L13.2475 4.99984L12.5404 5.70694L11.8333 4.99984ZM1.83331 5.99984C1.28103 5.99984 0.833313 5.55212 0.833313 4.99984C0.833313 4.44755 1.28103 3.99984 1.83331 3.99984V5.99984ZM9.20709 0.959397L12.5404 4.29273L11.1262 5.70694L7.79287 2.37361L9.20709 0.959397ZM12.5404 5.70694L9.20709 9.04028L7.79287 7.62606L11.1262 4.29273L12.5404 5.70694ZM11.8333 5.99984H1.83331V3.99984H11.8333V5.99984Z"
                            fill="#fff"
                        />
                    </svg>
                </button>
            </div>
        </div>
    );
};
export default Pagination;
